import React from 'react';
import { Textarea, TextareaProps } from '@chakra-ui/react';

interface StrongTextareaProps extends TextareaProps {}

const StrongTextarea: React.FC<StrongTextareaProps> = (props) => {
  return (
    <Textarea
      focusBorderColor="primary.400"
      borderRadius="md"
      bg="white"
      _placeholder={{ color: 'gray.500' }}
      _hover={{ bg: 'gray.50' }}
      {...props}
    />
  );
};

export default StrongTextarea;
